import common from './common'
import { REPORT_PARAMS, PAGE_NUM, SDK_PRODUCT } from '@/config/dataMap'
import getClientInstallTime from '@/utils/getClientInstallTime'

const vip_version = REPORT_PARAMS.vip_version
const report_version = REPORT_PARAMS.report_version
const show_from = REPORT_PARAMS.show_from
const main_from = REPORT_PARAMS.main_from
const enter_time = REPORT_PARAMS.enter_time

const centerStayTimeKfmt =
    'duba_newvip_center_staytime:6300 stay_time:int version:byte show_from:int vip_version:int show_if:byte show_page:byte show_fail_reason:string show_time:int product_id:int'

const homeOperateKfmt =
    'duba_newvip_main_operate:8760 main_click:byte main_hover:short version:byte sub_mode:short show_from:int vip_version:int enter_time:string page_num:byte product_id:int tab_click:byte user_login:byte user_status:byte days:int staytime:int review_cnt:int order_notice:int'
const homeContentShowKfmt =
    'duba_newvip_mainpage_contentshow:6301 main_from:int show_content2:string version:byte vip_version:int show_content:byte product_id:int'

export default {
  API: {
    method1 () {
    }
  },
  REPORT: {
    // 会员中心停留时长统计
    reportCenterStayTimeKfmt (params) {
      const info = {
        stay_time: parseInt(
          (new Date().getTime() - performance.timing.fetchStart) / 1000
        ),
        show_from,
        show_if: 1,
        show_page: 0,
        show_fail_reason: '',
        show_time: 0,
        vip_version,
        version: report_version,
        product_id: SDK_PRODUCT.id,
      }
      return common.REPORT.client_report_by_kfmt(centerStayTimeKfmt, common.API.replaceObj(info, params))
    },

    async reportHomeOperate (params) {
      const info = {
        main_click: 0,
        main_hover: 0,
        sub_mode: 0,
        show_from,
        enter_time,
        version: 7,
        vip_version,
        page_num: PAGE_NUM[window.app.$route.name],
        product_id: SDK_PRODUCT.id,
        tab_click: 0,
        user_login: 0,
        user_status: 0,
        days: 0,
        staytime: 0,
        review_cnt: 0,
        order_notice: 0,
      }
      try {
        const { install_days } = await getClientInstallTime()
        info.days = install_days
        // 获取staytime
        params.staytime = params.stay_time ? params.stay_time : 0
      } catch (error) {
        console.log(error)
      }
      return common.REPORT.client_report_by_kfmt(homeOperateKfmt, common.API.replaceObj(info, params))
    },

    reportHomeContentShow (params) {
      const info = {
        main_from,
        show_content2: '',
        show_content: 0,
        version: report_version,
        vip_version,
        product_id: SDK_PRODUCT.id
      }
      return common.REPORT.client_report_by_kfmt(homeContentShowKfmt, common.API.replaceObj(info, params))
    }
  }
}
